import { render, staticRenderFns } from "./BlocksFavourites.vue?vue&type=template&id=4ec4b780&scoped=true"
import script from "./BlocksFavourites.vue?vue&type=script&lang=ts"
export * from "./BlocksFavourites.vue?vue&type=script&lang=ts"
import style0 from "./BlocksFavourites.vue?vue&type=style&index=0&id=4ec4b780&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec4b780",
  null
  
)

export default component.exports